// src/services/authService.js
import { api } from './apiService';

export async function saveGoogleUser(userData) {
  try {
    const response = await api.post(`/users/register`, userData);
    // Save response to localStorage
    localStorage.setItem('userInfo', JSON.stringify(response.data));
    return response.data;
  } catch (err) {
    throw err;
  }
}

export async function googleLogin(userData) {
  try {
    const response = await api.post(`/users/login`, userData);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function googleRegister(userData) {
  try {
    userData.source = 'google';
    const response = await api.post(`/users/register`, userData);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function linkedinLogin() {
  try {
    const response = await api.get(`/users/auth/linkedin`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function linkedinRegister() {
  try {
    const response = await api.get(`/users/auth/linkedin`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function sendOTP(userEmail, type) {
  try {
    const response = await api.post(`/users/email-otp`, {userEmail, type});
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function verifyOTP(userEmail, otp, type) {
  try {
    const response = await api.post(`/users/verify-otp`, {userEmail, otp, type});
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function verifyListOTP(email, otp, listId) {
  try {
    const response = await api.post(`/public/list/verify-otp`, {email, otp, listId});
    return response.data;
  } catch (error) {
    throw error;
  }
}

export function logoutUser() {
  localStorage.removeItem('userInfo');
}
